/**
 * Debug/Test-Funktionalität für den Sonnen-Lebenszyklus.
 * Toggle zwischen Echtzeit und beschleunigtem Testmodus.
 */
import type { Engine } from '../core/Engine';
import type { SunLifecycleEntry, SunFate } from './SunLifecycleTypes';

export class SunLifecycleDebug {
  private _testLifetimeSec: number | null = null;
  private _engine: Engine | null = null;

  get testLifetimeSec(): number | null { return this._testLifetimeSec; }
  get testMode(): boolean { return this._testLifetimeSec !== null; }

  init(engine: Engine): void {
    this._engine = engine;
    document.addEventListener('keydown', this._onKey);
  }

  toggleTestMode(
    onReset: () => void,
    _entries: ReadonlyMap<string, SunLifecycleEntry>,
  ): void {
    this._testLifetimeSec = this._testLifetimeSec === null ? 40 : null;
    onReset();
    console.log('[SunLifecycle] Modus:', this._testLifetimeSec ? `TEST (${this._testLifetimeSec}s)` : 'ECHTZEIT');
  }

  toggleTestFate(
    rawMap: Map<string, { fate: SunFate }>,
    entries: Map<string, SunLifecycleEntry>,
  ): void {
    if (this._testLifetimeSec === null) return;

    let hasBlackHole = false;
    for (const raw of rawMap.values()) {
      if (raw.fate === 'black_hole') hasBlackHole = true;
    }
    const newFate: SunFate = hasBlackHole ? 'explode' : 'black_hole';

    for (const [id, raw] of rawMap) {
      raw.fate = newFate;
      const entry = entries.get(id);
      if (entry) entry.fate = newFate;
    }

    console.log('[SunLifecycle] TestFate toggled:', newFate);
    if (this._engine) {
      this._engine.events.emit('sun:lifecycle-update', entries);
    }
  }

  private _onToggle: (() => void) | null = null;
  private _onFateToggle: (() => void) | null = null;

  setHandlers(onToggle: () => void, onFateToggle: () => void): void {
    this._onToggle = onToggle;
    this._onFateToggle = onFateToggle;
  }

  private _onKey = (e: KeyboardEvent): void => {
    if (e.key === 'l' || e.key === 'L') this._onToggle?.();
    if (this._testLifetimeSec !== null && (e.key === 'e' || e.key === 'E')) {
      this._onFateToggle?.();
    }
  };

  dispose(): void {
    document.removeEventListener('keydown', this._onKey);
  }
}
